export default __webpack_public_path__ + "static/media/GraphicDesign2.6993c362.png";